import axios from "../http_v2";
export default {
  list(params) {
    return axios.get("content-service/aggregatepage/page", params);
  },
  list_org(params) {
    return axios.get("content-service/aggregatepage/page_org", params);
  },
  add(params) {
    return axios.post("content-service/aggregatepage", params);
  },
  update(params) {
    return axios.put("content-service/aggregatepage", params);
  },
  del(params) {
    return axios.delete("content-service/aggregatepage/" + params.id, {});
  },
  info(params) {
    return axios.get("content-service/aggregatepage/" + params.id);
  },
  cntsourcelogs(params) {
    return axios.post("cmsservice/tracklog/cntsourcelogs", params);
  }
    
};
